import { useEffect, useState } from 'react';
import Pagination from '../components/Pagination';
import { isEmpty } from 'lodash';

const useItemsPaginator = (originalList, itemsPerPage = 6) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (originalList) {
      setItems(originalList.filter((item, index) => index < itemsPerPage));
    }
  }, [originalList]);

  const onChangePage = (page) => {
    const from = itemsPerPage * (page - 1);
    const to = itemsPerPage * page;
    setItems(originalList.filter((item, index) => index >= from && index < to));
  };

  const Component = !isEmpty(originalList) ? (
    <Pagination onChange={onChangePage} pageItems={itemsPerPage} list={originalList} />
  ) : null;

  return {
    items,
    PaginatorComponent: Component,
  };
};

export default useItemsPaginator;
